import { useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { useAutoScroll } from 'utils/hooks'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'
import { useSpaCart } from './hooks/useSpaCart'
import { UpsellsContext } from 'routes/Upsell/utils/upsellsContext'
import { darkMode } from 'styles/theme'
import spaAndWellnessImg from 'assets/images/amenitiesAndAttractions/spaAndWellness.jpg'
import spaAndWellnessImgMobile from 'assets/images/amenitiesAndAttractions/spaAndWellnessMobile.jpg'
import Attraction from 'components/shared/Attraction'
import SpaModal from 'routes/Upsell/SpaModal'
import { WELLNESS_PRICE } from 'constants/prices'
import SpaCreator from './SpaCreator'
import { SpaConfirmDeleteModal } from './SpaConfirmDeleteModal'

const SpaAttraction = () => {
    const { formatMessage } = useIntl()
    const { calculateScroll, animatePendingScroll, scrollIndex } =
        useAutoScroll()
    const { isMobile } = useResolutions()
    const { isDarkThemeForSpa } = usePromotions()
    const { cartItems } = useSpaCart()
    const { isEditingSpaInProgress, setSpaEditing } = useContext(UpsellsContext)

    const [isSpaModalOpen, setIsSpaModalOpen] = useState(false)
    const [isConfirmationModalOpened, setIsConfirmationModalOpened] =
        useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const sectionId = 'spa-box'

    const label = formatMessage({
        id: 'upsells.general.order_online',
        defaultMessage: 'Rezerwuj online',
    })

    const handleToggleSpaModal = (isOpened: boolean) => {
        setIsSpaModalOpen(isOpened)
    }

    const handleTriggerButtonClick = () => {
        isDropdownOpen ? handleRemoveUpsell() : handleAddUpsell()
    }

    const handleRemoveUpsell = () => {
        if (cartItems.length) setIsConfirmationModalOpened(true)
        else {
            setIsDropdownOpen(false)
            setSpaEditing(false)
            calculateScroll({
                trigerringSection: 'spa',
                trigerringAction: 'cancel_empty',
                hasInstantScroll: true,
            })
        }
    }

    const handleCloseConfirmationModal = () =>
        setIsConfirmationModalOpened(false)

    const handleSubmitConfirmationModal = () => {
        setIsConfirmationModalOpened(false)
        setIsDropdownOpen(false)
        setSpaEditing(false)
        calculateScroll({
            trigerringSection: 'spa',
            trigerringAction: 'delete_all',
            hasInstantScroll: true,
        })
    }

    const handleAddUpsell = () => {
        setIsDropdownOpen(true)
    }

    useEffect(() => {
        if (cartItems.length) setIsDropdownOpen(true)
        else if (!cartItems.length && !isEditingSpaInProgress)
            setIsDropdownOpen(false)
    }, [cartItems, isEditingSpaInProgress])

    useEffect(() => {
        animatePendingScroll(sectionId)
        if (isDarkThemeForSpa) animatePendingScroll('spa-promo-info')
    }, [scrollIndex])

    return (
        <>
            <Attraction
                id={sectionId}
                isAvailableOnline={true}
                title="Wellness & SPA (16+)"
                price={WELLNESS_PRICE}
                isPriceFrom={true}
                details={[
                    formatMessage({
                        id: 'upsells.wellness.abstract',
                        defaultMessage:
                            'Zrelaksuj się dzięki naszym wyjątkowym masażom i specjalnym zabiegom na całe ciało!',
                    }),
                ]}
                images={[spaAndWellnessImgMobile, spaAndWellnessImg]}
                handleButtonClick={handleTriggerButtonClick}
                creator={
                    <SpaCreator
                    // TODO: add full dark theme - after MVP
                    // ! try not to use theme but just boolean flag, ex. hasDarkTheme
                    // ! consider using param or hook within creator component
                    // theme={
                    //     isDarkThemeForSpa
                    //         ? getDarkModeByLanguage(language)
                    //         : undefined
                    // }
                    />
                }
                isDropdownOpen={isDropdownOpen}
                handleModalOpening={() => handleToggleSpaModal(true)}
                label={isMobile ? label.toUpperCase() : label}
                isAdded={!!cartItems.length}
                theme={isDarkThemeForSpa ? darkMode : undefined}
                hasDarkMode={isDarkThemeForSpa}
            />
            <SpaConfirmDeleteModal
                isOpened={isConfirmationModalOpened}
                onClose={handleCloseConfirmationModal}
                onSubmit={handleSubmitConfirmationModal}
            />
            <SpaModal
                isOpened={isSpaModalOpen}
                closeModal={() => handleToggleSpaModal(false)}
            />
        </>
    )
}

export default SpaAttraction
